/**
 * Created by yz on 2017/3/27.
 */
{
    angular.module('interfaceModule')
        .controller('PayController',PayController);
    PayController.$inject = ['$scope',"$state",'$http','$stateParams','request.order',
    'ModalWindow','utils.currentUser','utils.common','utils.platform',
    'utils.constant','$timeout','requestHandler'];
    function PayController($scope,$state,$http,$stateParams,orderRequest,
    	ModalWindow,currentUser,common,platform,
        constant, $timeout,requestHandler) {
        let vm=this;
        let collect={
            'activate':activate,
            'docInfo':null,
            'printInfo':null,
            'orderInfo':null,
            'payOrder':payOrder,
            'payMethod':2,
            // 'selectPayMethod':selectPayMethod,
            'gotoPreview':gotoPreview,
            'gotoSettings':gotoSettings,
            'cancelOrderConfirm':cancelOrderConfirm,
            'qrpayModal':null,
            'isMobile':false,
            'isWechat':false,
            'isIOS':false,
            'appPayUrl_ali':constant.config.sitePath+constant.action.appPay_ali,
            'appPayUrl_wechat':constant.config.sitePath+constant.action.appPay_wechat,
            'timer':null,
            'timer1':null,
            'checkInterval':1000,//每次检测支付结果的间隔
            'checking':false,
            'checkPayResult':checkPayResult,
            'notWechatHint':notWechatHint,
            //小强新加的
            'balancePay':balancePay,
            // ryj 2019-7-7，添加woPay声明
            'woPay':woPay,
            // ryj 2021-6-8，添加bocPay声明
            'bocPay':bocPay,
            'bocPayDescription':"",
            'bocDiscount_0':1,
            'bocpayamount_0':"",
            'bocDiscount_1':1,
            'bocpayamount_1':"",
            'payamount':"",
            'monthPay':monthPay,
            'getUserInfo':getUserInfo,
            'userInfo':null,
            'userId':null,
            'userFullInfo':null,
            'manager':true,
            'companyUser': false,
            'mobilePay': mobilePay,

            'selectPayType':selectPayType,
            'getDiscountInfo':getDiscountInfo,//获取支付方式折扣
            'r_discount':100,//优惠折扣
            'r_amount':null,
            'discountinfo':null,
            'paiddate':null,
            'refreshorderstatus':refreshorderstatus//登录后查询是否有订单支付过(点击支付有操作记录) 却状态为 未支付
        };
        vm.collect=collect;
        activate();

        function activate(){
            common.loading.show();
            collect.isMobile=platform.isIOS()||platform.isAndroid();
            collect.isWechat=platform.isWechat();
            collect.isIOS=platform.isIOS();

            collect.payMethod=2;
            if (currentUser.info){
                console.log('支付页面当前用户信息',currentUser.info);
                collect.userInfo = currentUser.info;
                collect.userId = currentUser.info.userId;
                //判断是否企业用户来是否显示月结选项
                if(collect.userInfo.groupname === "企业用户" || collect.userInfo.groupname === "企业管理用户"){
                    collect.companyUser = true;
                }
            }else{
                $scope.$on('user.logged', function(event,data){
                    console.log('支付页面用户信息');
                    console.log('user.logged',data);
                    collect.userInfo = data;
                    collect.userId = data.userId;
                    if(collect.userInfo.groupname === "企业用户" || collect.userInfo.groupname === "企业管理用户"){
                        collect.companyUser = true;
                    }
                });
            }
            sessionStorage.setItem("userId",collect.userId);
             getUserInfo();
            $scope.$on("$destroy", function(e) {
                    console.log('$on');
                    if(collect.qrpayModal){
                        console.log('collect.qrpayModal');
                        collect.qrpayModal.close();
                    }
                
            });
            getDiscountInfo();
            getOrderInfo();
            getOrderBOCPayInfo();
            $scope.$on("$destroy", function(e) {
                console.log(collect.timer);
                $timeout.cancel(collect.timer);
                
            });
            requestHandler.simpleRequest(constant.action.getUserId).then(function (respone) {
                common.loading.show();
                if(respone.data[0].result==1){
                    collect.userId=respone.data[0].loginuserid;
                    console.log("当前登录用户id",collect.userId);
                    refreshorderstatus();
                }else{
                    $state.go('login');
                }

            })
        }


        //获取个人详细信息
        function getUserInfo() {
            let params=[{
                'userid': collect.userId,
            }];
            let str='userinfo='+JSON.stringify(params);
            requestHandler.simpleRequest(constant.action.getUserInfoById,str).then(function (respone) {
                // console.log("是否管理员信息：",respone);
                // console.log(respone);   //这里有用户的个人信息，比如是否管理员
                collect.userFullInfo = respone.data[0].users.rows[0];
            });

        }


        //为预览功能做的准备
        function setCover(docId,pageNum){

            let path=constant.config.sitePath+constant.config.previewPath+"/";

            if (collect.docInfo.fileName.toLowerCase().endsWith(".doc") || collect.docInfo.fileName.toLowerCase().endsWith(".docx"))
            {
                collect.docInfo.coverPath=path+"file_type_word.png";
            }
            else if (collect.docInfo.fileName.toLowerCase().endsWith(".ppt") || collect.docInfo.fileName.toLowerCase().endsWith(".pptx"))
            {
                collect.docInfo.coverPath=path+"file_type_ppt.png";
            }
            else if (collect.docInfo.fileName.toLowerCase().endsWith(".pdf"))
            {
                collect.docInfo.coverPath=path+"file_type_pdf.png";
            }
            else {
                collect.docInfo.coverPath=path+"file_type_image.png";
            }
        }

        // 获取中行支付信息
        function getOrderBOCPayInfo() {
            let data={
                'userid':       collect.userId,
                'orderid':      $stateParams.orderId,
                'ordertype':    0,
                'amount':       0
            };

            let paramsStr='orderinfo='+JSON.stringify(data);

            requestHandler.simpleRequest(constant.action.appPay_boc_amoundQuery_new, paramsStr,
                function successCallback(response) {
                    console.log(response);

                    collect.bocDiscount_0 = response.data.bocdiscount_0;
                    collect.bocDiscount_1 = response.data.bocdiscount_1;

                    /*
                    if (response.data.orderindex === 1)
                    {
                        collect.bocPayDescription = "当月首单1折优惠，5元封顶，订单金额1元以下免单";
                    }
                    else if (response.data.orderindex >= 2 && response.data.orderindex <= 4)
                    {
                        collect.bocPayDescription = "随机优惠，订单金额1元以下免单";
                    }
                    else
                    {
                        collect.bocPayDescription = "";
                    }
                    */
                    collect.bocPayDescription = "";

                    collect.payamount = response.data.payamount;
                    collect.bocpayamount_0 = response.data.payamount_0;
                    collect.bocpayamount_1 = response.data.payamount_1;

                    /*if (collect.bocDiscount_0 == 0)
                    {
                        collect.payMethod = 8;
                        collect.orderInfo.amount = collect.bocpayamount_0;
                    }
                    else if (collect.bocDiscount_1 == 0)
                    {
                        collect.payMethod = 7;
                        collect.orderInfo.amount = collect.bocpayamount_1;
                    }
                    else*/
                    {
                        collect.payMethod = 6;
                        collect.orderInfo.amount = collect.payamount;
                    }
                },
                function errorCallback(response) {
                    console.log('获取boc支付信息失败');
                    console.log(response);
                }
            );
        }

        //获取订单信息
        function getOrderInfo(){
            orderRequest.getOrderInfo($stateParams.orderId)
            .then(function(data){
                // console.log('成功拿到订单信息',data);
                collect.docInfo=data.docInfo;
                collect.printInfo=data.printInfo;
                collect.orderInfo=data.orderInfo;
                if(collect.orderInfo.status!=1){
                    $state.go('main.order');
                }else{
                    common.loading.hide();
                }
                collect.r_amount = collect.orderInfo.amount;//
                setCover(collect.docInfo.docId,collect.docInfo.pageNum);
                selectPayType(collect.payMethod);
                if(collect.isMobile){
                    console.log('getOrderInfo++++++++++++++++++++++++++++++++++++++++');
                     checkPayResult();
                 }
            })
        }
        //手机第三方支付：点击按钮触发
        function mobilePay(){
          //浏览器存储支付方式：
            var _payMethod = collect.payMethod,
                _amount = collect.orderInfo.amount,
                _discount = collect.r_discount;
            sessionStorage.setItem('payMethod',_payMethod);
            sessionStorage.setItem('amount',_amount);
            sessionStorage.setItem('discount',_discount);
            let data=[{
                'operation':0,
                'paymethod':_payMethod,
                'orderid':collect.orderInfo.orderId
            }];
            let paramsStr='payinfo='+JSON.stringify(data);
            // requestHandler.simpleRequest(constant.action.orderpayquery,paramsStr);      //测试用接口标记，所以注释这里。


        }

        // ryj 2019-7-7 添加woPay函数实现
        function woPay(){
            console.log('进行沃支付');

            //浏览器存储支付方式：
            var _payMethod = collect.payMethod,
                _amount = collect.orderInfo.amount,
                _discount = collect.r_discount;
            sessionStorage.setItem('payMethod',_payMethod);
            sessionStorage.setItem('amount',_amount);
            sessionStorage.setItem('discount',_discount);
            let data=[{
                'operation':0,
                'paymethod':_payMethod,
                'orderid':collect.orderInfo.orderId
            }];
            let paramsStr='payinfo='+JSON.stringify(data);

            requestHandler.simpleRequest(constant.action.appPay_wo, paramsStr,
                function successCallback(response) {
                    console.log(response);

                    var form = $("<form></form>")
                    form.attr('action',response.data[0].gate_way)
                    form.attr('method','post')
                    var input1 = $("<input type='hidden' name='param' />")
                    input1.attr('value',response.data[0].params)
                    form.append(input1)
                    form.appendTo("body")
                    form.css('display','none')
                    form.submit()

                    /*
                    requestHandler.simpleRequest(response.data[0].gate_way, response.data[0].params,
                        function successCallback(response) {
                            console.log(response);
                        }
                    );
                    */
                },
                function errorCallback(response) {
                    console.log('支付出现失败');
                    let alert=common.alert('',
                        '连接不到数据库，请查看网络',
                        [{
                            'title':'确认',
                            'action':function(){
                                alert.close();
                            }
                        }]);
                    // 请求失败执行代码
                }

            );

        }

        // ryj 2021-6-8 添加bocPay函数实现
        function bocPay(){
            console.log('进行中行支付');

            /*
            orderinfo: {
                userid,			// 用户账号ID
                    orderid,			// 订单号
                    ordertype,		// 订单类型，0：普通订单，1：充值订单
                    amount,			// 充值订单金额，取值：6，10。
                    subject,			// 订单标题（上传文件名称）
                    discounttype,       // 6：不使用优惠，7：使用随机优惠，8：使用1折优惠
            }
            */

            //浏览器存储支付方式：
            let data={
                'userid':collect.userId,
                'orderid':$stateParams.orderId,
                'ordertype':0,
                'amount':0,
                'subject':collect.docInfo.fileName,
                'discounttype':collect.payMethod
            };
            let paramsStr='orderinfo='+JSON.stringify(data);

            requestHandler.simpleRequest(constant.action.appPay_boc_new, paramsStr,
                function successCallback(response) {
                    console.log(response);

                    /*
                    1 $('#payType').attr("value", obj['payType']);
                    2 $('#orderNo').attr("value", obj['orderNo']);
                    3 $('#curCode').attr("value", obj['curCode']);
                    4 $('#orderAmount').attr("value", obj['orderAmount']);
                    5 $('#orderTime').attr("value", obj['orderTime']);
                    6 $('#orderNote').attr("value", obj['orderNote']);
                    7 $('#terminalChnl').attr("value", obj['terminalChnl']);
                    8 $('#payPattern').attr("value", obj['payPattern']);
                    9 $('#merchantNo').attr("value", obj['merchantNo']);
                    10 $('#orderUrl').attr("value", obj['orderUrl']);
                    11 $('#signData').attr("value", obj['signData']);
                    */

                    var form = $("<form></form>");
                    form.attr('action','https://ebspay.boc.cn/PGWPortal/B2CMobileRecvOrder.do');
                    form.attr('method','post');

                    var input1 = $("<input type='hidden' name='payType' />");
                    input1.attr('value',response.data.payType);
                    form.append(input1);

                    var input2 = $("<input type='hidden' name='orderNo' />");
                    input2.attr('value',response.data.orderNo);
                    form.append(input2);

                    var input3 = $("<input type='hidden' name='curCode' />");
                    input3.attr('value',response.data.curCode);
                    form.append(input3);

                    var input4 = $("<input type='hidden' name='orderAmount' />");
                    input4.attr('value',response.data.orderAmount);
                    form.append(input4);

                    var input5 = $("<input type='hidden' name='orderTime' />");
                    input5.attr('value',response.data.orderTime);
                    form.append(input5);

                    var input6 = $("<input type='hidden' name='orderNote' />");
                    input6.attr('value',response.data.orderNote);
                    form.append(input6);

                    var input7 = $("<input type='hidden' name='terminalChnl' />");
                    input7.attr('value',response.data.terminalChnl);
                    form.append(input7);

                    var input8 = $("<input type='hidden' name='payPattern' />");
                    input8.attr('value',response.data.payPattern);
                    form.append(input8);

                    var input9 = $("<input type='hidden' name='merchantNo' />");
                    input9.attr('value',response.data.merchantNo);
                    form.append(input9);

                    var input10 = $("<input type='hidden' name='orderUrl' />");
                    input10.attr('value',response.data.orderUrl);
                    form.append(input10);

                    var input11 = $("<input type='hidden' name='signData' />");
                    input11.attr('value',response.data.signData);
                    form.append(input11);

                    form.appendTo("body");
                    form.css('display','none');
                    form.submit();
                },
                function errorCallback(response) {
                    console.log('支付出现失败');
                }
            );
        }

        //点击确认支付按钮进行余额支付：
        function balancePay(){
                common.loading.show();
                // console.log('进行余额支付');
                // console.log(vm.collect.orderInfo);
                // console.log(collect.userInfo);
                let _data = [{
                    'userid':collect.userInfo.userId,
                    'orderid':collect.orderInfo.orderId,
                    'amount': parseFloat(collect.orderInfo.amount),
                    'transtype': 1,               // 余额应用分类： 1：使用余额
                    'discount':collect.r_discount
                }];
                // console.log('传给后台的数据',_data);
                let paramsStr='transaction='+JSON.stringify(_data);
                /*
                * log start
                * */
                let _logdata = [{
                    "querytype":0,
                    "userid": collect.userInfo.userId,
                    "logcontent":'余额支付：'+paramsStr,

                }];
                let paramslog='debuglog='+JSON.stringify(_logdata);
                requestHandler.simpleRequest(constant.action.debuglog, paramslog,function (data) {
                    // console.log("debug返回：",data);
                });
                /*
                * log end
                * */
                requestHandler.simpleRequest(constant.action.balancetransaction, paramsStr,
                    function successCallback(response) {
                        common.loading.hide();
                        console.log(response);
                        //还要考虑一种余额不够以致支付失败的情况
                        if(response.data[0].result==1){
                            let alert=common.alert('',response.data[0].msg,
                                [{
                                    'title':'确认'
                                }]
                            )
                            collect.timer1 = $timeout(function(){
                                alert.close();
                                console.log('跳转到支付成功paySuccess页面');
                                $state.go('main.paySuccess',{'orderId':collect.orderInfo.orderId});
                            },500);

                        }else if(response.data[0].result==0){
                            if(response.data[0].msg =="余额不足！"){
                                console.log('余额不足！');
                                let alert=common.alert('',
                                    response.data[0].msg +'  先去充值？',
                                    [{
                                        'title':'其它方式',
                                        'action':function(){
                                            alert.close();
                                        }
                                    },{
                                        'title':'充值',
                                        'action':function(){
                                            alert.close();
                                            $state.go('main.recharge',{'userId':collect.userInfo.userId});
                                        }
                                    }]);
                            }else{
                                let alert=common.alert('',response.data[0].msg,
                                    [{
                                        'title':'确认',
                                        'action':function(){
                                            alert.close();
                                        }
                                    }]
                                )
                            }

                        }

                    },
                    function errorCallback(response) {
                        console.log('支付出现失败');
                        let alert=common.alert('',
                            '连接不到数据库，请查看网络',
                            [{
                                'title':'确认',
                                'action':function(){
                                    alert.close();
                                }
                            }]);
                        // 请求失败执行代码
                    }

                );

        }

        //月结支付
        function monthPay(){
            common.loading.show();
            console.log('用户进行月结');

            var _data = [{
                'userid':collect.userInfo.userId,
                'orderid':collect.orderInfo.orderId,
                'amount': parseFloat(collect.orderInfo.amount),
                'transtype': 1,
                'discount': collect.r_discount,
                'paymethod':3
            }];
            console.log('collect.orderInfo.amount：',_data[0].amount);
            console.log('传给后台的数据：', _data);
            let paramsStr='companyuserpay='+JSON.stringify(_data);
            /*
                     * log start
                     * */
            let _logdata = [{
                "querytype":0,
                "userid": collect.userInfo.userId,
                "logcontent":'月结支付：'+paramsStr,

            }];
            let paramslog='debuglog='+JSON.stringify(_logdata);
            requestHandler.simpleRequest(constant.action.debuglog, paramslog,function (data) {
                console.log("debug返回：",data);
            });
            /*
            * log end
            * */
            requestHandler.simpleRequest(constant.action.companyuserpayment, paramsStr,
                function successCallback(response) {
                    console.log('成功访问',response);
                    common.loading.hide();
                    if(response.data[0].result == 0){
                        let alert = common.alert('',response.data[0].msg,
                            [{
                                'title': '确认',
                                'action': function (){
                                    alert.close();
                                }
                            }]
                        )
                    }else if(response.data[0].result == 1){
                        let alert = common.alert('',response.data[0].msg,
                            [{
                                 'title': '确认',
                                 'action': function (){
                                     alert.close();
                                     console.log('跳转到支付成功paySuccess页面');
                                     $state.go('main.paySuccess',{'orderId':collect.orderInfo.orderId});
                                 }
                            }]
                        );

                    }


                },
                function errorCallback(response) {
                    console.log('失败访问',response);
                }

            );
        }

        //点击扫码支付按钮进行扫码支付
        function payOrder(){
            common.loading.show();
            let data=[{
                'operation':0,
                'paymethod':collect.payMethod,
                'orderid':collect.orderInfo.orderId
            }];
            let paramsStr='payinfo='+JSON.stringify(data);
            requestHandler.simpleRequest(constant.action.orderpayquery,paramsStr).then(function () {
                collect.orderInfo.payAction = 1;    //表示是付款使用
                //请求获取支付二维码，成功返回data数据对象
                orderRequest.getPayQrcode(collect.payMethod,
                    collect.orderInfo.orderId,
                    collect.docInfo.fileName,
                    collect.orderInfo.amount)
                    .then(function(data){
                        console.log(data);
                        common.loading.hide();
                        $scope.orderInfo=collect.orderInfo;
                        $scope.payMethod=collect.payMethod;
                        $scope.qrcode=data.qrcode;   //这是支付二维码的URL
                        collect.qrpayModal=ModalWindow.open({
                            'templateUrl':'app/views/modals/qrpayModal.html',
                            'controller':'QrpayModalController',
                            'width':320,
                            'height':360,
                            'scope':$scope,
                            'windowClass':"qrpay_window"
                        });
                    },function(data){
                        console.log('调用二维码不成功',data);
                        common.loading.hide();
                    });
            })


        }

        function notWechatHint(){
            let alert=common.alert(null,'请使用微信浏览器打开');
        }

        //点击删除按钮，进入删除订单确认弹窗
        function cancelOrderConfirm(){
            let alert=common.alert('删除订单',
                '您确定删除订单么？',
                [{
                    'title':'取消',
                    'action':function(){
                        alert.close();
                    }
                },{
                    'title':'删除',
                    'action':function(){
                        alert.close();
                        cancelOrder()
                    }
                }]);
            
        }

        //检查支付结果   手机端用的
        function checkPayResult(){
            var  _payMethod = JSON.parse(sessionStorage.getItem('payMethod')),
                 _amount = JSON.parse(sessionStorage.getItem('amount')),
                 _discount = JSON.parse(sessionStorage.getItem('discount')),
                price=null;

            // ryj can not
            console.log('checkPayResult++++++++++++++++++++++++++++++++++++++++');

            /*
             * log start
             * */

            /*
            let _logdata = [{
                "querytype":0,
                "userid": collect.userInfo.userId,
                "logcontent":'手机端订单设置为已支付：orderprintid：'+collect.orderInfo.orderPrintId+"，price："+_amount+",paytype:"+_payMethod+",discount:"+_discount

            }];
            let paramslog='debuglog='+JSON.stringify(_logdata);
            requestHandler.simpleRequest(constant.action.debuglog, paramslog,function (data) {
                console.log("debug返回：",data);
            });
            */
            /*
            * log end
            * */

            console.log('checkPayResult 1 :',_payMethod,collect.orderInfo.orderId);

            orderRequest.checkPayResult(_payMethod,collect.orderInfo.orderId)
            .then(function (resData){
                console.log('手机端检测支付信息：',resData)
                if(_payMethod==0){
                    collect.hasPaid=resData.trade_status=="TRADE_SUCCESS";
                    collect.paiddate=resData.send_pay_date;//第三方得到的支付时间
                    price=resData.total_amount;//第三方得到的支付金额
                }else if(_payMethod==1){
                    collect.hasPaid=resData.trade_state=="SUCCESS";
                    collect.paiddate=resData.time_end;//第三方得到的支付时间
                    price=(resData.total_fee)*1/100;//第三方得到的支付金额

                }
                if(collect.hasPaid){
                    common.loading.hide();
                    orderRequest.setOrderPaid(collect.orderInfo.orderPrintId,price,_payMethod,collect.paiddate,_discount).then(function (data) {
                        if(data[0].result==1){
                            sessionStorage.removeItem('payMethod');
                            sessionStorage.removeItem('amount');
                            sessionStorage.removeItem('discount');
                            $state.go('main.paySuccess',{'orderId':collect.orderInfo.orderId});
                        }else{
                            collect.timer=$timeout(checkPayResult,collect.checkInterval);
                        }
                    });
                }else{
                    collect.timer=$timeout(checkPayResult,collect.checkInterval);
                }
            },
            function (resData){
                collect.timer=$timeout(checkPayResult,collect.checkInterval);
            }
            );
        }

        //发出请求进行删除订单
        function cancelOrder(){
            common.loading.show();
            orderRequest.cancelOrder(collect.orderInfo.orderPrintId)
            .then(function(data){
                common.loading.hide();
                if(data.result==1){
                    $state.go('main.orderDetail',{'orderId':collect.orderInfo.orderId});
                    common.prompt('删除订单成功');
                }else{
                    common.prompt('删除订单失败');
                }
            });
        }
         //预览文档
        function gotoPreview(){
            $state.go('main.preview',{'orderId':collect.orderInfo.orderId});
        }
        //修改订单
        function gotoSettings(){
            $state.go('main.printSettings',{'orderId':collect.orderInfo.orderId});
        }
        //选择支付方式 0支付宝 1微信 2余额 3月结 5 沃支付
        function selectPayType(payMethod) {
            collect.payMethod = payMethod;
            if(collect.discountinfo){
                switch (payMethod){
                    case 0:
                        collect.r_discount = collect.discountinfo.alipay;
                        break;
                    case 1:
                        collect.r_discount = collect.discountinfo.wechat;
                        break;
                    case 2:
                        collect.r_discount = collect.discountinfo.balance;
                        break;
                    case 3:
                        collect.r_discount = collect.discountinfo.monthpay;
                        break;
                        // ryj 2019-7-7, 添加沃支付功能
                    case 5:
                        collect.r_discount = collect.discountinfo.wechat;
                        break;
                        // ryj 2021-6-14, 添加中行支付功能
                    case 6:
                    case 7:
                    case 8:
                        collect.r_discount = collect.discountinfo.wechat;
                        break;
                }

                if (payMethod == 6)
                {
                    collect.orderInfo.amount = collect.payamount;
                }
                else if (payMethod == 7)
                {
                    collect.orderInfo.amount = collect.bocpayamount_1;
                }
                else if (payMethod == 8)
                {
                    collect.orderInfo.amount = collect.bocpayamount_0;
                }
                else
                {
                    console.log("collect.r_amount",collect.r_amount);
                    collect.r_discount=parseInt(collect.r_discount);
                    console.log("打折后：",(collect.r_amount*collect.r_discount/100));
                    collect.orderInfo.amount = (collect.r_amount*collect.r_discount/100);
                }
            }else{
                getDiscountInfo();
                getOrderInfo();
            }

        }
        //查询各支付方式的折扣
        function getDiscountInfo(payMethod){
            // console.log("查询各支付方式折扣");
            var _data = [{
                'userid':sessionStorage.getItem('userId')
            }];
            // console.log('传给后台的数据：', _data);
            let paramsStr='discountinfo='+JSON.stringify(_data);
            requestHandler.simpleRequest(constant.action.paydiscountquery,paramsStr,
            function (response) {
                if(response.data[0].result==1){
                    console.log("返回的折扣信息：",response.data[0].discountinfo);
                    collect.discountinfo = response.data[0].discountinfo;

                }else if(response.data[0].result==0){
                    console.log("获取支付方式折扣失败");
                }
            }
            )

        }

        function refreshorderstatus() {
            common.loading.show();
            let data = [{
                'userid':collect.userId,
                'operation':1
            }];
            let param = "payinfo=" + JSON.stringify(data);
            requestHandler.simpleRequest(constant.action.orderpayquery,param,function(response){
                console.log("刷新订单后：",response);
                if(response.data[0].result==1){

                    $state.go('main.order');
                }else {
                    common.loading.hide();
                    getOrderBOCPayInfo();
                }
            });
        }
    }
    
}
